import { useEffect, useState } from 'react';
import segmentService from '../services/segment/segmentService';
import { useSelector } from 'react-redux';
import { StoreState } from '../types/store.type';
import ddLogger from '../logging/ddLogger';
import _ from 'lodash';

export function usePageViewTracker(): void {
    const { reservation, stay } = useSelector((store: StoreState) => store.trip);
    const [isPageTracked, setIsPageTracked] = useState(false);

    useEffect(() => {
        if (!_.isNil(reservation) && !_.isNil(stay) && !isPageTracked) {
            const reservationId = reservation.id;
            const pathname = window.location.pathname;

            // Update the global window object for GTM
            const details = {
                reservation_source_id: reservation.reservation_source_id || '',
                reservation_source_name: reservation.reservation_source_type || '',
                reservation_id: reservationId || '',
                confirmation_code: reservation.confirmation_code || '',
                check_in_date: stay.check_in_date || '',
                check_out_date: stay.check_out_date || '',
                total: reservation.total || '',
            };

            const existingDetails = (window as any).ReservationDetails || {};

            (window as any).ReservationDetails = { ...details, ...existingDetails };

            segmentService.trackPageView();
            ddLogger.info(`PageView - ${pathname}, ReservationId:${reservationId}`, { reservationId, pathname });

            setIsPageTracked(true);
        }
    }, [reservation, stay]);
}
